import { scaleLinear } from 'd3-scale';
import { useMemo } from 'react';
import { Scale } from '../types/scale';
import { getExtent } from '../utils/scale';

export const useLeadScale = (xScale: Scale) => {
  const range = getExtent(xScale.range());
  const domain = getExtent(xScale.domain());

  return useMemo(() => {
    return scaleLinear().domain([0, domain]).range([0, range]);
  }, [domain, range]);
};
